/* eslint-disable no-restricted-globals */
import buildNotification from 'nike-ui/src/common/messaging/buildNotification';
import { initializeApp } from 'firebase/app';
import { getMessaging, onBackgroundMessage } from 'firebase/messaging/sw';

const { apiKey, appId, messagingSenderId, projectId } = self.FIREBASE_CONFIG;
let messaging;
if (!messaging) {
    messaging = getMessaging(initializeApp({ apiKey, appId, messagingSenderId, projectId }));
}
onBackgroundMessage(messaging, payload => {
    const { title, options } = buildNotification(payload.data);
    return self.registration.showNotification(title, options);
});

self.addEventListener('notificationclick', event => {
    event.notification.close();
    event.waitUntil(self.clients.openWindow(event.notification.data.url));
});
